import { JSONSchemaType } from 'ajv'

export interface IProjectExecutionFormData {
  name: string
  sellerId: string
  buyerId: string
  definitions: string
  status: string
  executedAt: string
  isInactive: boolean
}

const ProjectExecutionSchema: JSONSchemaType<IProjectExecutionFormData> = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    sellerId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    buyerId: {
      type: 'string',
    },
    definitions: {
      type: 'string',
    },
    executedAt: {
      type: 'string',
    },
    status: {
      type: 'string',
    },
    isInactive: {
      type: 'boolean',
      default: false,
    },
  },
  required: ['name', 'sellerId', 'buyerId'],
  additionalProperties: false,
}

export default ProjectExecutionSchema
